import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';

@Component({
    selector: 'app-rent-car-card-list',
    templateUrl: './rent-car-card-list.component.html',
    styleUrls: ['./rent-car-card-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentCarCardListComponent {

  businessLine: CarBusinessLine = CarBusinessLine.RENT; 

}
